import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { RxButtonComponent } from '@nrwl/rx-button';

@Component({
  selector: 'rx-upload-thumbnail',
  templateUrl: './rx-upload-thumbnail.component.html',
  styleUrls: ['./rx-upload-thumbnail.component.scss'],
  imports: [CommonModule, RxButtonComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxUploadThumbnailComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RxUploadThumbnailComponent),
      multi: true,
    },
  ],
})
export class RxUploadThumbnailComponent
  implements OnInit, ControlValueAccessor, OnChanges, Validator
{
  public transparentPixel =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

  @Input()
  public label = '';

  @Input()
  public value;

  @Output()
  public valueChange: EventEmitter<any> = new EventEmitter();

  @Output()
  public thumbChanged: EventEmitter<any> = new EventEmitter();

  public control: FormControl;

  public onChange = (value: string) => {};

  public onTouched = () => {};

  constructor() {}

  public ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges | any): void {
    this.onChange(this.value);
  }

  public changeChecked(event) {
    this.onChange(event.checked);
    this.valueChange.emit(event.checked);
  }

  // Register for change
  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  // Register for touch/click
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Update the model and changes
  public writeValue(value: string): void {
    if (this.value !== value) {
      this.value = value;
      this.onChange(this.value);
    }
  }

  public isValid(): boolean {
    return this.control && !this.control.pending && !this.control.errors && !this.control.invalid;
  }

  // validate
  public validate(control: FormControl): any {
    //ValidationErrors
    this.control = control;
    return control.valid ? null : control.errors;
  }

  public selectFile(event): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      const reader = new FileReader();
      reader.onload = (res: any) => {
        this.value = res.target.result;
        this.onChange(this.value);
        //this.onChange(event.target.files[0]);
        this.thumbChanged.emit(event.target.files[0]);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public updateThumb() {
    this.value = null;
    this.onChange(this.value);
    this.thumbChanged.emit(this.value);
  }
}
